// =============================================================================
// clientes/src/App.tsx — o portal do parceiro (migração 062), mobile-first.
//
// Três estados de porta: sem login → /login; login sem chapéu de parceiro →
// "fale com a loja" (a conta existe no GoTrue mas não em partner_accounts, ou
// foi desativada — a RLS já devolve vazio de qualquer jeito, a tela só explica);
// com chapéu → catálogo, carrinho e pedidos.
// =============================================================================
import { Navigate, Route, Routes } from 'react-router';
import Aviso from './componentes/Aviso';
import Carregando from './componentes/Carregando';
import Marca from './componentes/Marca';
import Layout from './componentes/Layout';
import { useSessao } from './lib/sessao';
import { configurado } from './lib/supabase';
import Carrinho from './paginas/Carrinho';
import Catalogo from './paginas/Catalogo';
import Login from './paginas/Login';
import Pedidos from './paginas/Pedidos';

export default function App() {
  const { session, cadastro, erro, recarregar, carregando, sair } = useSessao();

  if (!configurado) {
    return (
      <div className="mx-auto max-w-md p-6">
        <Aviso tipo="erro">
          Falta configurar VITE_SUPABASE_ANON_KEY — ver clientes/.env.example.
        </Aviso>
      </div>
    );
  }

  if (carregando) return <Carregando texto="Abrindo o portal" />;

  if (!session) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // NÃO DEU PARA PERGUNTAR ≠ NÃO TEM ACESSO. Provado no smoke de 25/08/2026:
  // o schema cache do PostgREST estava velho, a RPC devolveu 404 e a tela
  // dizia ao parceiro que o acesso dele não estava liberado — mandando a loja
  // procurar defeito no cadastro quando o problema era do servidor.
  if (erro) {
    return (
      <div className="mx-auto flex min-h-svh max-w-md flex-col items-center justify-center gap-4 p-6 text-center">
        <Marca className="h-10 w-auto text-signal" />
        <h1 className="text-lg font-black">Não deu para abrir o portal</h1>
        <Aviso tipo="erro">{erro}</Aviso>
        <p className="text-sm text-mute">
          Isto é um problema do servidor, não do seu acesso. Tente de novo em
          instantes; se continuar, avise a loja.
        </p>
        <div className="flex gap-2">
          <button type="button" className="botao-primario px-4 py-2 text-sm"
                  onClick={() => void recarregar()}>
            Tentar de novo
          </button>
          <button type="button" className="botao-secundario px-4 py-2 text-sm"
                  onClick={() => void sair()}>
            Sair
          </button>
        </div>
      </div>
    );
  }

  if (!cadastro) {
    return (
      <div className="mx-auto flex min-h-svh max-w-md flex-col items-center justify-center gap-4 p-6 text-center">
        <Marca className="h-10 w-auto text-signal" />
        <h1 className="text-lg font-black">Acesso não liberado</h1>
        <p className="text-sm text-mute">
          Sua conta existe, mas ainda não está vinculada a um cliente da loja —
          ou o acesso foi desativado. Fale com a Serginho Autopeças pelo
          telefone de sempre.
        </p>
        <button type="button" className="botao-secundario px-4 py-2 text-sm" onClick={() => void sair()}>
          Sair
        </button>
      </div>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Catalogo />} />
        <Route path="/carrinho" element={<Carrinho />} />
        <Route path="/pedidos" element={<Pedidos />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
